<template lang="html">
  <div class="customizer-external-includes-korea-headers">
    <div
      :class="[
        'header-container',
        { 'expanded': showHeaderContainer },
        { 'show-dropdown': showCountryDropdown }
      ]">
      <div class="main-header-container vans-korea">
        <div class ="brand">
          <a :href="baseUrl">
            <div class="brand-logo"></div>
          </a>
        </div>
        <div class="upper-right-area">
          <ul class="upper-right-bar">
            <li @click="clickCountryBar(true)" class="country-bar">
              <a href="javascript:;" >
                <svg width="10px" viewBox="0 0 460 512">
                  <path fill="#000" d="M5 185.466l67.589-67.615 157.423 157.399 157.399-157.399 67.589 67.615-224.988 224.988z"></path>
                </svg>
                <span>지역</span>
              </a>
              <ul
                @focusout="focusoutCountryDropdown"
                ref="headerDropdown"
                tabindex="-1"
                :class="[ 'country-dropdown', { 'expanded': showCountryDropdown } ]"
              >
                <li>
                  <a href="http://www.vans.co.kr/"><span>대한민국</span></a>
                 </li>
                <li>
                  <a href="http://www.vans.com.hk/en/"><span>Hong Kong SAR</span></a>
                 </li>
                <li>
                  <a href="http://www.vans.com.hk/"><span>香港特別行政區</span></a>
                 </li>
                <li>
                  <a href="http://vans.com.cn/"><span>中国</span></a>
                 </li>
                <li>
                  <a href="http://www.vans.com.sg/"><span>Singapore</span></a>
                 </li>
                <li>
                <li>
                  <a href="http://www.vans.co.in/"><span>India</span></a>
                 </li>
                <li>
                  <a href="http://www.vans.com.my/"><span>Malaysia</span></a>
                 </li>
                <li>
                  <a href="http://www.vans.com/shop.html"><span>USA</span></a>
                 </li>
                <li>
                  <a href="http://www.vans.ca/en_ca/homepage.html"><span>Canada (English)</span></a>
                </li>
                <li>
                  <a href="http://www.vans.ca/fr_ca/homepage.html">
                    <span>Canada (Français) </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.mx/es_mx/homepage.html">
                    <span>Méjico (Español) </span>
                  </a>
                </li>
                <li>
                  <a href="http://vansdobrasil.com/">
                    <span>Brasil </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vansargentina.com/">
                    <span>Argentina </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.at/">
                    <span>Österreich </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.fr/">
                    <span>France </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.de/">
                    <span>Deutschland </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.ie/">
                    <span>Ireland </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.eu/">
                    <span>Israel </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.it/">
                    <span>Italia </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.nl/">>
                    <span>Nederland </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.eu/">
                    <span>Polska </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.pt/">
                    <span>Portugal </span>
                  </a>
                </li>
                <li>
                  <a href="http://vans.ru/">
                    <span>Россия </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.es/">
                    <span>España </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.se/">
                    <span>Sweden </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.eu/">
                    <span>Switzerland </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.eu/">
                    <span>Türkiye </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.co.uk/">
                    <span>United Kingdom </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vansjapan.com/">
                    <span>日本 </span>
                  </a>
                </li>
              <!--  <li>
                  <a href="http://www.vanstaiwan.com/">
                    <span>台灣 </span>
                  </a>
                </li> -->
                <li>
                  <a href="http://www.vans.net.au/">
                    <span>Australia </span>
                  </a>
                </li>
                <li>
                  <a href="http://www.vans.co.nz/">
                    <span>New Zealand </span>
                  </a>
                </li>
              </ul>
            </li>
            <li class="location-bar">
              <a :href="`${ baseUrl }/map`">
                <svg width="25" viewBox="0 0 792 1024">
                  <path d="M736.97 366.932c0-201.956-153.6-366.932-341.334-366.932s-341.334 164.978-341.334 366.932v2.844c0 295.822 301.512 634.31 301.512 634.31 11.378 11.378 25.6 19.912 39.822 19.912v0c14.222 0 28.444-5.688 39.822-19.912 2.844-5.688 301.512-347.022 301.512-634.312v0-2.844zM395.636 512c-93.868 0-170.668-76.8-170.668-170.668s76.8-170.668 170.668-170.668 170.666 76.8 170.666 170.668-76.8 170.668-170.668 170.668z"></path>
                </svg>
                <span>STORE</span>
              </a>
            </li>
            <li class="cart-bar">
              <a :href="`${ baseUrl }/cart`">
                <svg  width="30px" viewBox="0 0 1114 1024">
                  <path d="M20.732 46.289h222.66l84.675 247.749h765.208l-112.901 470.415h-589.586l-228.937-624.082-141.126 3.135v-97.217zM459.784 667.236h445.325l59.586-275.974h-598.993l94.082 275.974zM453.513 802.091c-50.179 0-87.811 37.632-87.811 87.811 0 47.044 40.767 87.811 87.811 87.811s87.811-37.632 87.811-87.811c3.135-50.179-37.632-87.811-87.811-87.811zM864.343 802.091c-50.179 0-87.811 37.632-87.811 87.811 0 47.044 40.767 87.811 87.811 87.811 50.179 0 87.811-37.632 87.811-87.811s-37.632-87.811-87.811-87.811z"></path>
                </svg>
                <span>쇼핑백</span>
              </a>
            </li>
            <li class="account-bar">
              <a :href="`${ baseUrl }/login`">
                <svg width="30" viewBox="0 0 458 512">
                  <path d="M10.947 495.832c0-45.81 0-86.231 0-133.389 55.242-25.6 110.484-51.2 168.421-78.147-14.821-43.116-32.337-80.842-41.769-121.263-10.779-47.158-12.126-99.706 40.421-122.611 28.294-12.127 71.411-12.127 99.706 1.347 49.853 24.252 49.853 76.8 37.726 123.958-9.432 39.073-26.947 74.106-43.116 117.221 56.589 26.947 114.526 53.894 171.116 79.495 0 47.158 0 87.579 0 132.042-145.516 1.348-288.337 1.348-432.505 1.348z"></path>
                </svg>
                <span>로그인</span>
              </a>
            </li>
            <li @click="clickMenuBar()" class="menu-bar">
              <a href="javascript:;" >
                <svg  width="30" viewBox="0 0 512 512">
                  <path d="M32 96h448v96h-448zM32 224h448v96h-448zM32 352h448v96h-448z"></path>
                </svg>
              </a>
            </li>
          </ul>
        </div>
        <div :class="[ 'nav-bar', { 'expanded': showNavBar } ]">
          <ul class= "nav-list">
            <li><a :href="`${ baseUrl }/category/new`">NEW</a></li>
            <li><a :href="`${ baseUrl }/category/men`">MEN</a></li>
            <li><a :href="`${ baseUrl }/category/women`">WOMEN</a></li>
            <li><a :href="`${ baseUrl }/category/kids`">KIDS</a></li>
            <li><a :href="`${ baseUrl }/category/custom`">CUSTOMS</a></li>
          </ul>
        </div>
        <div @click="clickHideHeader()" :class="[ 'hide-header', { 'expanded': showHideHeader } ]">
          <div class="hide-indicator">
            <svg width="15px" viewBox="0 0 460 512">
              <path fill="#fff" d="M229.978 381.202l225.449-250.266h-450.897l225.447 250.266z"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'koreaHeaders',
  data() {
    return {
      showHeaderContainer: false,
      showHideHeader: false,
      showNavBar: false,
      showCountryDropdown: false
    };
  },
  computed: {
    baseUrl() {
      const { mainSiteUrls } = this.$store.state.endPoints.customizer;
      const { env } = this.$store.state.utils;
      let baseUrl = '';

      if (!!mainSiteUrls && mainSiteUrls[env]) {
        baseUrl = mainSiteUrls[env];
      }

      return baseUrl;
    }
  },
  methods: {
    clickHideHeader() {
      this.showHeaderContainer = !this.showHeaderContainer;
    },
    clickMenuBar() {
      this.showHideHeader = !this.showHideHeader;
      this.showNavBar = !this.showNavBar;
    },
    focusoutCountryDropdown(ev) {
      if (!this.$refs.headerDropdown.contains(ev.relatedTarget)) {
        this.clickCountryBar();
      }
    },
    clickCountryBar(state = false) {
      this.showCountryDropdown = state;

      if (state) {
        this.$nextTick(() => this.$refs.headerDropdown.focus());
      }
    },
    hideElements() {
      this.showHeaderContainer = false;
      this.showHideHeader = false;
      this.showNavBar = false;
      this.showCountryDropdown = false;
    },
    setDataLayer() {
      window.dataLayer = [ {
          "pageName": "customizer",
          "pageCategory": "customs",
          "platform": "customizer",
          "language": "ko",
          "country": "KR",
          "currency": "KRW",
          "currencySymbol": "￦"
      } ];

      this.$customsGTM.GTMScript("GTM-NN5WPNN");
    }
  },
  created() {
    this.setDataLayer();
    this.$eventBus.$on('changeExternalHeadersVisibility', this.hideElements);
  },
  beforeDestroy() {
    this.$eventBus.$off('changeExternalHeadersVisibility', this.hideElements);
  }
}
</script>
